import api from '..';

class LettersSoundsSyllablesGameApi {
    static getItem(params) {
        return api.axios.get('/letters-sounds-syllables/item', { params }).then(({ data }) => data.item);
    }
}

export default LettersSoundsSyllablesGameApi;
